/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 18V17.5V17.4C2 15.1598 2 14.0397 2.43597 13.184C2.81947 12.4314 3.43139 11.8195 4.18404 11.436C5.03968 11 6.15979 11 8.4 11H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 11L17 6M22 11L17 16M22 11H10.5H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M22 11L17 6M22 11L17 16M22 11H8.4C6.15979 11 5.03968 11 4.18404 11.436C3.43139 11.8195 2.81947 12.4314 2.43597 13.184C2 14.0397 2 15.1598 2 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M22 11L17 6M22 11L17 16M22 11H8.4C6.15979 11 5.03968 11 4.18404 11.436C3.43139 11.8195 2.81947 12.4314 2.43597 13.184C2 14.0397 2 15.1598 2 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 6L22 11H8.4C6.15979 11 5.03968 11 4.18404 11.436C3.43139 11.8195 2.81947 12.4314 2.43597 13.184C2 14.0397 2 15.1598 2 17.4V17.5V18M17 16L19.5 13.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 11L17 6M22 11L17 16M22 11H8.4C6.15979 11 5.03968 11 4.18404 11.436C3.43139 11.8195 2.81947 12.4314 2.43597 13.184C2 14.0397 2 15.1598 2 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M22 11L17 6M22 11L17 16M22 11H8.4C6.15979 11 5.03968 11 4.18404 11.436C3.43139 11.8195 2.81947 12.4314 2.43597 13.184C2 14.0397 2 15.1598 2 17.4V17.5V18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
